// Lee el token de la cookie "info"
export const getTokenFromCookie = () => {
    try {
        const cookieValue = document.cookie
            .split('; ')
            .find(row => row.startsWith('info='))
            ?.split('=')[1];
        
        if (!cookieValue) return null;
        
        const parsed = JSON.parse(decodeURIComponent(cookieValue));
        return parsed.token || null;
    } catch {
        return null;
    }
};

// Valida el token contra el backend
export const validateToken = async (token) => {
    try {
        const response = await fetch('https://rembackprod.wdi.net/validate-token-web-view', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error('Token validation failed');
        }

        const data = await response.json();
        
        if (data.code !== 0) {
            throw new Error(data.description || 'Invalid token response');
        }

        return data.data; // Devuelve el número de teléfono
    } catch (error) {
        console.error('Error validating token:', error);
        throw error;
    }
};